<script>
import Vue from 'vue';
import "@plugins/bootstrap/css/bootstrap.min.css"
import "@plugins/bootstrap/js/bootstrap.min.js"
import "@backend/css/animate.css"
import "@backend/css/style.css"
import "@backend/css/colors/blue.css"
import "@backend/css/custom.scss"

import "@plugins/jquery-validation/jquery-validation.js"
import "@backend/js/jquery.slimscroll.js"
import "@backend/js/waves.js"
import "@backend/js/custom.js"
import "@backend/js/main.js"

// VueFormWizard
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard)

Vue.component("ImagePreview",()=>import("@backend/components/ImagePreview.vue"))
Vue.component("BoField",()=>import("@backend/components/BoField.vue"))
Vue.component("SortField",()=>import("@backend/components/SortField.vue"))
Vue.component("StatusLabel",()=>import("@backend/components/StatusLabel.vue"))
Vue.component("FileManager",()=>import("@components/FileManager.vue"))
Vue.component("PriceFormat",()=>import("@backend/components/PriceFormat.vue"))
Vue.component("DateRangePicker",()=>import("@backend/components/DateRangePicker.vue"))

export default {
  name:"BoMain",
  mounted(){
    $("title").text("Small ERP Application - Lingkar9")
  }
}
</script>

<template>
  <router-view/>
</template>